/* unplugin-vue-components disabled */import script from "./menu-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./menu-item.vue?vue&type=script&setup=true&lang=ts"

import "./menu-item.vue?vue&type=style&index=0&id=06ea61e8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06ea61e8"]])

export default __exports__